import { render } from "./ListeProduit.vue?vue&type=template&id=297fa8f4&scoped=true&ts=true"
import script from "./ListeProduit.vue?vue&type=script&lang=ts"
export * from "./ListeProduit.vue?vue&type=script&lang=ts"

import "./ListeProduit.vue?vue&type=style&index=0&id=297fa8f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297fa8f4"]])

export default __exports__